export default __webpack_public_path__ + "static/media/Daftar Warga.c2fd4881.png";